import React from "react";
import logo from "../../../../assets/image/logo.webp";
import Image from "../../../elements/Image";
import { useSelector } from "react-redux";

const TakeActionStepFour = () => {
  const { siteSetting } = useSelector((state) => state.setting);

  return (
    <>
      <div className="relative py-10 space-y-10">
        <div className="space-y-10 text-center w-full max-w-sm mx-auto">
          <div className="space-y-4">
            <div className="text-9xl text-chestnut-rose">
              <i className="fa-solid fa-fw fa-heart"></i>
            </div>
            <div className="text-3xl text-chestnut-rose">
            You did it! 🌱 Your action today inspires tomorrow.
            </div>
          </div>
          <div className="text-3xl">
            A confirmation is on its way to your email.
          </div>
          <div className="text-2xl">Every dollar counts—thank you!</div>
          <div className="h-20 mx-auto flex justify-center">
            <Image
              src={siteSetting?.logo?.url}
              alt={""}
              effect="blur"
              classes="object-contain"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TakeActionStepFour;
